import { LinkTarget, ProjectCardItem, PublicationCardItem } from 'app/core/cms/generated/api-types'

export function createCmsLinkFromCardItem(card: PublicationCardItem | ProjectCardItem): LinkTarget {
  return {
    enabled: true,
    type: 'relationship',
    internal: {
      relationTo: card.__typename === 'Project' ? 'projects' : 'publications',
      value: {
        slug: card.slug,
        title: card.title,
      },
    },
    filter: null,
    url: null,
    asset: null,
    email: null,
  }
}
